import { defineComponent } from "@vue/composition-api";
import { VerifySurveyAuth } from "@components/auth";

const Page = defineComponent({
	render(){
		return <VerifySurveyAuth/>
	}
});

export default Page;